import doorState from 'config/doorState';
import unloadSpeed from 'config/unloadSpeed';

export const aggregateDoorStats = (data = []) => {
  if (!Array.isArray(data)) return {};

  return {
    unloading: data.filter(door => door.door_state === doorState.UNLOADING).length,
    stopped: data.filter(door => door.door_state === doorState.STOPPED).length,
    empty: data.filter(door => door.door_state === doorState.EMPTY).length,
    employees: data.reduce((total, door) => total + door.people_active, 0),
  };
};


/**
 * Filter doors by state, progress and percentage
 * @param {*} data  
 * @param {
 *  doorState: string
 *  progess: number,
 *  percentage: number,
 *  sort: {
 *    progress: [order]
 *    percentage: [order]
 *  }
 * } qry 
 */
export const filterDoorsData = (data = [], qry = {}) => {
  let result = data.slice(0);

  // filter doorState
  result = result.filter(item => filterStatus(item, qry.doorState));

  // apply filters and sort only for all and status in progress, stopped and finished
  if (qry.doorState === '' ||
      qry.doorState === 'IN_PROGRESS' ||
      qry.doorState === doorState.STOPPED ||
      qry.doorState === doorState.FINISHED ||
      qry.doorState === 'FAVORITES' ||
      qry.doorState === doorState.NOT_STARTED) {
    
    // For NOT_STARTED tab, ignore progress/speed filters
    if (qry.doorState !== doorState.NOT_STARTED && (qry.progress !== '' || qry.speed !== '')) {
      const allowStatuses = [
        doorState.LOADING,
        doorState.UNLOADING,
        doorState.STOPPED,
      ];

      if (qry.progress !== '') {
        allowStatuses.push(doorState.FINISHED);
      }

      result = result.filter(item => filterStatusIn(item, allowStatuses));
      result = result.filter(item => filterProgress(item, qry.progress));
      result = result.filter(item => filterSpeed(item, qry.speed));
    }

    if (qry.direction !== '') {
      result = result.filter(item => filterStatusIn(item, [
        doorState.LOADING,
        doorState.UNLOADING,
        doorState.STOPPED,
        doorState.FINISHED,
        doorState.NOT_STARTED,
      ]));
      result = result.filter(item => filterDirection(item, qry.direction));
    }

    if (qry.customer && qry.customer !== '') {
      result = result.filter(item => filterStatusIn(item, [
        doorState.LOADING,
        doorState.UNLOADING,
        doorState.STOPPED,
        doorState.FINISHED,
        doorState.NOT_STARTED,
      ]));
      result = result.filter(item => filterCustomer(item, qry.customer));
    }
  }

  // if (qry.doorState !== '' || qry.doorState !== 'FAVORITES') {
  //   result = result.filter(item => item.maintenance_mode !== 1);
  // }

  // sorts
  if (qry.sort && qry.sort.key !== '') {
    const [key, ord] = qry.sort.split('_');
    const order = ord === 'asc' ? 1 : -1;

    const emptyDoors = result.filter(item => {
      return item.door_state === doorState.EMPTY || item.door_state === doorState.NOT_STARTED;
    });
    result = result.filter(item => !emptyDoors.includes(item));

    switch (key) {
      case 'progress':
        result.sort((a, b) => {
          return order * sortByProgress(a, b);
        });
        break;
        
        case 'speed':
        result.sort((a, b) => {
          return order * sortBySpeed(a, b);
        });
      break;

      default:
        // eslint
    }

    emptyDoors.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    result = result.concat(emptyDoors);

  } else if (qry.progress === '' && qry.speed === '') {
    result.sort(sortByFavorite);
  }

  return result;
};

const filterStatus = (item, status) => {
  const val = item.door_state;
  switch (status) {
    case '': return true;
    case 'IN_PROGRESS': return val === doorState.LOADING || val === doorState.UNLOADING;
    case 'FAVORITES': return item.is_favorite;
    default: return val === status;
  }
};

const filterStatusIn = (item, statuses) => {
  return statuses.includes(item.door_state);
};

const filterProgress = (item, progress) => {
  if (progress === '') return true;

  const val = parseInt(progress, 10);
  if (typeof val !== 'number' || isNaN(val)) return false;
  
  const min = (val * 0.25) + (val ? 0.01 : 0), max = (val + 1) * 0.25;
  return item.unloaded_percent >= min && item.unloaded_percent <= max;
};

const filterSpeed = (item, speed) => {
  if (speed === '') return true;
  if (item.door_state === doorState.EMPTY || item.door_state === doorState.NOT_STARTED) {
    return false;
  }
  return item.relative_speed === speed.toUpperCase();
};

const filterDirection = (item, direction) => {
  switch (direction) {
    case 'inbound':
      return item.direction === 'UNLOAD';

    case 'outbound':
      return item.direction === 'LOAD';

    default:
      return false;
  }
};

const filterCustomer = (item, customer) => {
  if (!customer) return true;
  return (item.customer_name || '') === customer;
};

const sortByProgress = (a, b) => {
  if (a.unloaded_percent < b.unloaded_percent) return -1;
  if (a.unloaded_percent > b.unloaded_percent) return 1;
  else return 0;
};


const sortBySpeed = (a, b) => {
  const ai = unloadSpeed.getValues().indexOf(a.relative_speed);
  const bi = unloadSpeed.getValues().indexOf(b.relative_speed);

  if (ai < bi) return -1;
  else if (ai > bi) return 1;
  else {
    const unloadDiffA = Math.abs(a.unloaded_percent_forecast - a.unloaded_percent);
    const unloadDiffB = Math.abs(b.unloaded_percent_forecast - b.unloaded_percent);
    return unloadDiffB - unloadDiffA;
  }
};

const sortByFavorite = (a, b) => {
  return b.is_favorite - a.is_favorite;
};

export const isStorageOrPallets = (item = {}) => {
  const name = (item.customer_name || "").trim().toLowerCase();
  const code = item.container_code || "";
  return (
    name === "storage" ||
    name === "pallets" ||
    code === "Equipment used for Storage" ||
    code === "Equipment used for Pallets"
  );
};

export const showDropdownFilters = (selected) => {
  switch (selected) {
    case "":
    case "FAVORITES":
    case "IN_PROGRESS":
    case doorState.STOPPED:
    case doorState.FINISHED:
      return true;
    default:
      return false;
  }
};